import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";
import { Status } from "../types/state";
import { getFieldOrdering } from "../utils/ordering";

export const getCollectionYardVisitEvents = (state: RootState) => state.collectionYardVisitEvents;

export const getCollectionYardVisitEventsList = (state: RootState) => state.collectionYardVisitEvents.list;

export const getCollectionYardVisitEventsSummary = (state: RootState) => state.collectionYardVisitEvents.summary;

export const getIsCollectionYardVisitEventsStatusLoading = (state: RootState): boolean =>
  state.collectionYardVisitEvents.status !== Status.success;

export const getCollectionYardVisitEventsFilters = (state: RootState) => state.collectionYardVisitEvents.filters;

export const getCollectionYardVisitEventsFilterValue = (state: RootState, filterId: string) =>
  state.collectionYardVisitEvents.filters.items.find((item) => item.id === filterId);

export const getCollectionYardVisitEventsFilterValueCached = createSelector(
  [getCollectionYardVisitEventsFilterValue],
  (item) => item
);

export const getCollectionYardVisitEventsFilterIsActive = (state: RootState, fieldName: string) =>
  !!state.collectionYardVisitEvents.filters.items.find((item) => String(item.id).startsWith(fieldName));

export const getCollectionYardVisitEventsFilterIsActiveCached = (state: RootState, fieldName: string) =>
  !!state.collectionYardVisitEvents.filters.items.find((item) => String(item.id).startsWith(fieldName));

export const getCollectionYardVisitEventsOrderingValue = (state: RootState, fieldName: string) => {
  const ordering = state.collectionYardVisitEvents.ordering;
  if (!ordering || ordering.orderBy !== fieldName) return null;
  return getFieldOrdering(fieldName, ordering);
};
